import { useContext } from 'react';

import { OfferCardContext } from '../../../components/OfferCard/components/OfferCardContext';

export const useOfferCardContext = () => {
    return useContext(OfferCardContext);
};
